<template>
  <div class="comment-reply-container">
    <LoadingBox
      :is-loading="isLoading"
    />

    <picture class="avatar embed-responsive embed-responsive-1by1">
      <img
        class="embed-responsive-item"
        :src="comment.user.avatar"
      />
    </picture>
    
    <div class="comment-body">
      <div class="d-flex justify-content-between">
        <div class="comment-details">
          <span class="user-name">{{ comment.user.name }}</span>
          <div class="publish-date">{{ commentDate }}</div>
        </div>
        <TextButton
          v-if="comment.user.id == user.id"
          @click="deleteCommentReply"
        >
          <span class="delete-comment-text">excluir</span>
        </TextButton>
      </div>

      <div class="comment-content">{{ comment.comment }}</div>
    </div>
  </div>
</template>

<script>
  import { mapActions, mapGetters } from 'vuex'
  import 'moment/locale/pt'
  import moment from 'moment'
  import TextButton from '@/components/buttons/TextButton'
  import LoadingBox from '@/components/layout/LoadingBox'

  export default {
    components: {
      TextButton,
      LoadingBox,
    },

    props: {
      comment: { type: Object, default: () => ({}) }
    },

    data: () => ({
      isLoading: false
    }),

    computed: {
      ...mapGetters('user', ['user']),

      commentDate () {
        return moment(this.comment.created_at).fromNow()
      }
    },

    methods: {
      ...mapActions('courseGroup', ['deleteCourseGroupReply']),

      async deleteCommentReply () {
        if (!confirm('Tem certeza que deseja deletar seu comentário?')) {
          return null
        }

        this.isLoading = true

        await this.deleteCourseGroupReply({ courseId: this.comment.course_id, courseGroupId: this.comment.id})

        this.isLoading = false
      }
    }
  }
</script>

<style scoped lang="scss">
  .comment-reply-container {
    display: flex;

    .avatar {
      width: 30px;
      height: 30px;
      border-radius: 100%;
      flex-shrink: 0;
      margin-right: 10px;
    }

    .comment-body {
      width: 100%;

      .delete-comment-text {
        display: none;
        color: rgba(#000, .3);
        font-weight: 500;
        font-size: 13px;
      }

      &:hover .delete-comment-text { display: block }

      .comment-details {
        display: flex;
        align-items: center;
        margin-bottom: 2.5px;

        .publish-date {
          font-size: 13px;
          color: rgba(#000, .6);

          &:before {
            content: '•';
            margin: 0 6px;
            color: rgba(#000, .6);
          }
        }

        .user-name {
          font-family: 'Poppins';
          font-size: 14px;
          font-weight: 600;
        }
      }

      .comment-content {
        font-family: 'Lato';
        font-size: 14px;
      }
    }
  }
</style>